<template>
    <div style="width: 100%;height: 100%;">
        {{isaddPost+''}}
        <div v-if="isaddPost">
            
        </div>
        <div v-if="!isaddPost" class="list-box">
            <div class="role-list">
                <div>
                    <h4>角色管理
                        <div class="button-list">
                            <div class="search">
                                <input type="text" placeholder="请输入关键字搜索">
                                <button></button>
                            </div>
                            <button style="margin-right: 20px;" @click="deleteSome()">删除</button>
                            <button :style="{background:bgColor,borderColor:bgColor,color:'#fff'}" @click="addRoles()">添加角色</button>
                        </div>
                    </h4>
                    <div>
                        <el-table
                            ref="multipleTable"
                            :data="tableData"
                            style="width: 100%"
                            :header-row-style="{background:fontColor,overflow:'hidden',}"
                            :row-style="{overflow:'hidden',}"
                            :cell-style="{textAlign:'center',background:'#FAFAFA',boxShadow:' 0 0 0 0 #D9D9D9, inset 0 0 0 0 #D9D9D9'}"
                            height="780"
                            :header-cell-style="{background:fontColor,height:'34px',padding:0,textAlign:'center'}"
                            @selection-change="handleSelectionChange">
                            <el-table-column
                            type="selection"
                            width="45">
                            </el-table-column>
                            <el-table-column
                            label="操作"
                            fixed
                            width="100"
                            >
                            <template slot-scope="scope">
                                <p class="operation">
                                <span>编辑</span>
                                <span class="delete" @click="deleteSome(scope.row)">删除</span>
                                </p>
                            </template>
                            </el-table-column>
                            <el-table-column
                            label="角色名称"
                            width="160"
                            >
                            <template slot-scope="scope">
                                <span style="white-space: nowrap;margin-left: 10px">{{ scope.row.name }}</span>
                            </template>
                            </el-table-column>
                            <el-table-column
                            label="角色描述"
                            width="220"
                            >
                            <template slot-scope="scope">
                                <span style="white-space: nowrap;margin-left: 10px">{{ scope.row.name }}</span>
                            </template>
                            </el-table-column>
                        </el-table>
                    </div>

                </div>
            </div>
            <div class="people-list"></div>
        </div>
    </div>
</template>
<script>
export default {
    props:['isaddPost'],

    data(){
        return {
            bgColor:'',
            selectList:[],
             tableData: [
          {
            date: '2016-05-02',
            name: '王小虎',
            flag:false,
            address: '上海市普陀区金沙江路 1518 弄'
            }, {
            date: '2016-05-04',
            name: '王小虎',
            flag:false,
            address: '上海市普陀区金沙江路 1517 弄'
            }, {
            date: '2016-05-01',
            name: '王小虎',
            flag:false,
            address: '上海市普陀区金沙江路 1519 弄'
            }, {
            date: '2016-05-03',
            name: '王小虎',
            flag:false,
            address: '上海市普陀区金沙江路 1516 弄'
            }
            ],
             tableData1: [
          {
            date: '2016-05-02',
            name: '王小虎',
            flag:false,
            address: '上海市普陀区金沙江路 1518 弄'
            }, {
            date: '2016-05-04',
            name: '王小虎',
            flag:false,
            address: '上海市普陀区金沙江路 1517 弄'
            }, {
            date: '2016-05-01',
            name: '王小虎',
            flag:false,
            address: '上海市普陀区金沙江路 1519 弄'
            }, {
            date: '2016-05-03',
            name: '王小虎',
            flag:false,
            address: '上海市普陀区金沙江路 1516 弄'
            }
            ]
        }
    },
    created(){
        this.fontColor=this.$store.state.themeBG
        this.bgColor=this.$store.state.themeColor
    },
  
    methods:{
         handleSelectionChange(data){
            // console.log(data)
            this.selectList=data
        },
        addRoles(){
          // console.log(this)
        },
         deleteSome(data){   
            var deleteArr=[]
            if(data){
                deleteArr[0]=data;
            }else{
                deleteArr=this.selectList;
            }
            // console.log(deleteArr)
            this.isDelete=true;
        },
    }
}
</script>

<style scoped>
.list-box{
    width: 100%;height: 100%;
}
.role-list{
    width: 616px;
    padding-right: 30px;
    float: left;
    height: 100%;
    box-sizing: border-box;
}
.role-list>div{
    width: 100%;
    background: #fff;
    height: 100%;
    box-shadow: 0 2px 5px 0 rgba(0,0,0,0.10);
    padding: 0 30px;
    box-sizing: border-box;
    overflow: hidden;
}
.people-list{
    overflow: hidden;
    background: #fff;
    height: 100%;
    box-shadow: 0 2px 5px 0 rgba(0,0,0,0.10)
}
h4{
    color: #333;
    font-size: 18px;
    font-family: SourceHanSansCN-Medium;
    padding-left: 12px;
    position: relative;
    margin:30px 0;
}
h4 i{
    content: '';
    position: absolute;
    left: 0;
    top: 4px;
    height: 20px;
    width: 2px;
}
.button-list{
    overflow: hidden;
    float: right;
    margin-top: -2px;
}
.button-list>div{
    float: left;
    width: 220px;
    height: 28px;
    padding:0 28px 0 10px;
    box-sizing: border-box;
    position: relative;
    border: 1px solid #e7e7e7;
    background: #fff;
    margin-right: 20px;
}
.button-list>div button{
    width: 26px;
    min-width: 26px;
    border: 0 none;
    height: 26px;
    position: absolute;
    top: 0px;
    right:0px;
    background: red;
    margin: 0;
}
.button-list>div input{
    width: 100%;
    height: 20px;
}
.button-list button{
    float: left;
    background: #fff;
    height: 28px;
    min-width: 60px;
    border:1px solid #666;
    line-height: 27px;
    box-sizing: border-box;
    padding: 0 10px;color: #666;
}
</style>
<style>
.role-list .el-checkbox__input.is-checked .el-checkbox__inner,.role-list .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background: #F08B00;
    border-color: #F08B00;
}
</style>



// WEBPACK FOOTER //
// src/components/index/template.vue